"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _constants = require("@seedlang/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var CommentShowWrapper = function CommentShowWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _Class;
  return (0, _mobxReact.observer)(_class = (_class2 = (_Class = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "expandCreate", _descriptor, _this);
      _initializerDefineProperty(_this, "expandEdit", _descriptor2, _this);
      _initializerDefineProperty(_this, "expandFeedback", _descriptor3, _this);
      _initializerDefineProperty(_this, "expandDebugInfo", _descriptor4, _this);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "border",
      get: function get() {
        if (this.props.comment.hidden && (_state.AppUI.user.admin || _state.AppUI.user.moderator)) {
          return "2px solid ".concat(_constants.Theme.orange);
        } else if (this.props.comment.pinned) {
          return "2px solid ".concat(_constants.Theme.green);
        }
        var borderColor = _state.AppUI.layout.isNative ? _state.AppUI.layout.secondaryBackgroundColor : '#FFF';
        return "2px solid ".concat(borderColor);
      }
    }, {
      key: "offset",
      get: function get() {
        var depth = Math.min(4, this.props.comment.depth);
        return depth * this.props.indentation;
      }
    }, {
      key: "onDeleteComment",
      value: function onDeleteComment() {
        _state.ForumUI.commentStore.destroy({
          ids: {
            commentId: this.props.comment.id
          }
        }, this.props.onChange);
      }
    }, {
      key: "onToggleHidden",
      value: function onToggleHidden() {
        var hidden = !this.props.comment.hidden;
        _state.ForumUI.commentStore.update({
          data: {
            hidden: hidden
          },
          ids: {
            commentId: this.props.comment.id
          }
        }, this.props.onChange);
      }
    }, {
      key: "onToggleAutoHide",
      value: function onToggleAutoHide() {
        var hidden = !this.props.comment.user.autoHideComments;
        _state.ForumUI.userStore.update({
          data: {
            autoHideComments: hidden
          },
          ids: {
            userId: this.props.comment.user.id
          }
        }, this.props.onChange);
      }
    }, {
      key: "onTogglePinned",
      value: function onTogglePinned() {
        var pinned = !this.props.comment.pinned;
        _state.ForumUI.commentStore.update({
          data: {
            pinned: pinned
          },
          ids: {
            commentId: this.props.comment.id
          }
        }, this.props.onChange);
      }
    }, {
      key: "onToggleCreate",
      value: function onToggleCreate() {
        this.expandCreate = !this.expandCreate;
        this.expandEdit = false;
      }
    }, {
      key: "onToggleFeedback",
      value: function onToggleFeedback() {
        this.expandFeedback = !this.expandFeedback;
      }
    }, {
      key: "onToggleEdit",
      value: function onToggleEdit() {
        this.expandEdit = !this.expandEdit;
        this.expandCreate = false;
        if (this.expandEdit) {
          _state.ForumUI.setEditComment(this.props.comment);
        } else {
          _state.ForumUI.cancelEditComment();
        }
      }
    }, {
      key: "onToggleDebugInfo",
      value: function onToggleDebugInfo() {
        this.expandDebugInfo = !this.expandDebugInfo;
      }
    }, {
      key: "afterSubmitComment",
      value: function afterSubmitComment() {
        if (this.expandEdit) {
          this.onToggleEdit();
        } else {
          this.onToggleCreate();
        }
      }
    }, {
      key: "onClickFeedback",
      value: function onClickFeedback(feedbackType) {
        _state.ForumUI.feedbackStore.create({
          data: {
            feedbackType: feedbackType,
            commentId: this.props.comment.id,
            userId: _state.AppUI.user.id
          }
        }, this.props.onChange);
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          onDeleteComment: this.onDeleteComment,
          onToggleHidden: this.onToggleHidden,
          onToggleAutoHide: this.onToggleAutoHide,
          onTogglePinned: this.onTogglePinned,
          onToggleCreate: this.onToggleCreate,
          onToggleEdit: this.onToggleEdit,
          offset: this.offset,
          expandCreate: this.expandCreate,
          expandFeedback: this.expandFeedback,
          onToggleFeedback: this.onToggleFeedback,
          expandEdit: this.expandEdit,
          afterSubmitComment: this.afterSubmitComment,
          border: this.border,
          onClickFeedback: this.onClickFeedback,
          onToggleDebugInfo: this.onToggleDebugInfo,
          expandDebugInfo: this.expandDebugInfo
        }));
      }
    }]);
  }(_react["default"].Component), _Class.defaultProps = {
    userProfileImageSize: 50,
    padding: 20,
    indentation: 90,
    fontSize: 14,
    lineHeight: 18
  }, _Class), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "expandCreate", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "expandEdit", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "expandFeedback", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "expandDebugInfo", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "border", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "border"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "offset", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "offset"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onDeleteComment", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onDeleteComment"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onToggleHidden", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onToggleHidden"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onToggleAutoHide", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onToggleAutoHide"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onTogglePinned", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onTogglePinned"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onToggleCreate", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onToggleCreate"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onToggleFeedback", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onToggleFeedback"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onToggleEdit", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onToggleEdit"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onToggleDebugInfo", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onToggleDebugInfo"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterSubmitComment", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterSubmitComment"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onClickFeedback", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onClickFeedback"), _class2.prototype), _class2)) || _class;
};
CommentShowWrapper.displayName = 'CommentShowWrapper';
var _default = exports["default"] = CommentShowWrapper;